// extracted by mini-css-extract-plugin
export default {"select":"select-form-theme__select","arrow":"select-form-theme__arrow","arrowDown":"select-form-theme__arrowDown"};